import RangeSlider from 'react-bootstrap-range-slider';
import { Badge } from 'react-bootstrap';
import { useState } from 'react';
import './InjurySelector.css';

export function InjurySelector({ bodyPart, updateWithoutAttorney, updateWithAttorney, onSeverityChange, bodyIndex }) {

    const [value, setValue] = useState(0);

    const sliderChange = (newValue) => {
        setValue(newValue);
        updateWithoutAttorney(newValue * 100 * bodyPart.withoutAttorney, bodyIndex);
        updateWithAttorney(newValue * 100 * bodyPart.withAttorney, bodyIndex);
        onSeverityChange?.(bodyIndex, newValue);
    }

    const getSeverityColor = (severity) => {
        if (severity >= 7) return 'danger';
        if (severity >= 4) return 'warning';
        return 'success';
    };

    return (
        <div className="injury-selector-card">
            <div className="d-flex justify-content-between align-items-center">
                <div className="injury-selector-header mb-0">{bodyPart.bodyPart}</div>
                <div className="d-flex align-items-center gap-2" style={{ minWidth: '180px' }}>
                    <RangeSlider
                        value={value}
                        onChange={changeEvent => sliderChange(Number(changeEvent.target.value))}
                        min={0}
                        max={10}
                        tooltip='off'
                        style={{ width: '120px' }}
                    />
                    <Badge bg={getSeverityColor(value)}>
                        {value}/10
                    </Badge>
                </div>
            </div>
        </div>
    );
}